module.exports = __webpack_public_path__ + "img/costValueRed.229876c2.jpg";